@if (loading) {
  <maximizer-loader type="legacy"></maximizer-loader>
}

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>

<div class="h-full flex flex-col justify-between">
  <div class="grow flex flex-col bg-neutral-10 scrollbar p-2">
    <form [formGroup]="form.group" class="flex flex-col gap-4">
      <!-- EMAIL  -->
      <div class="bg-white rounded-sm flex flex-col p-2">
        <p class="subtitle-1 text-neutral-90 px-2">
          {{ 'outlook.preferences.sections.email' | translate }}
        </p>
        <div
          class="flex items-start justify-between gap-4 p-2"
          kendoTooltip
          [tooltipTemplate]="tooltipTemplate"
          position="top"
          [callout]="false"
          [showOn]="!userHasInsertRights ? 'hover' : 'none'"
          [title]="
            !userHasInsertRights
              ? ('outlook.errors.permission' | translate)
              : ''
          "
        >
          <div class="flex flex-col gap-1">
            <kendo-label
              [for]="saveNowSwitch"
              [text]="'outlook.preferences.saveNow.label' | translate"
              [labelCssClass]="'subtitle-2 text-neutral-90'"
            ></kendo-label>
            <span class="text-body text-neutral-70">
              {{ 'outlook.preferences.saveNow.description' | translate }}
            </span>
          </div>
          <kendo-switch
            #saveNowSwitch
            formControlName="saveNow"
            class="mt-1"
          ></kendo-switch>
        </div>

        <div
          class="flex items-start justify-between gap-4 p-2"
          kendoTooltip
          [tooltipTemplate]="tooltipTemplate"
          position="top"
          [callout]="false"
          [showOn]="!userHasInsertRights ? 'hover' : 'none'"
          [title]="
            !userHasInsertRights
              ? ('outlook.errors.permission' | translate)
              : ''
          "
        >
          <div class="flex flex-col gap-1">
            <kendo-label
              [for]="saveEmailDetailSwitch"
              [text]="
                'outlook.preferences.advancedEmailProperties.label' | translate
              "
              [labelCssClass]="'subtitle-2 text-neutral-90'"
            ></kendo-label>
            <span class="text-body text-neutral-70">
              {{
                'outlook.preferences.advancedEmailProperties.description'
                  | translate
              }}
            </span>
          </div>
          <kendo-switch
            #saveEmailDetailSwitch
            formControlName="saveEmailDetail"
            class="mt-1"
          ></kendo-switch>
        </div>
      </div>

      <!-- CALENDAR -->
      @if (outlookStore.saveAppointmentShown()) {
        <div class="bg-white rounded-sm flex flex-col p-2">
          <p class="subtitle-1 text-neutral-90 px-2">
            {{ 'outlook.preferences.sections.calendar' | translate }}
          </p>
          <div class="flex items-start justify-between gap-4 p-2">
            <div class="flex flex-col gap-1">
              <kendo-label
                [for]="saveAppointmentDetailSwitch"
                [text]="
                  'outlook.preferences.saveAppointmentDetail.label' | translate
                "
                [labelCssClass]="'subtitle-2 text-neutral-90'"
              ></kendo-label>
              <span class="text-body text-neutral-70">
                {{
                  'outlook.preferences.saveAppointmentDetail.description'
                    | translate
                }}
              </span>
            </div>
            <kendo-switch
              #saveAppointmentDetailSwitch
              formControlName="saveAppointmentDetail"
              class="mt-1"
            ></kendo-switch>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="bg-white flex justify-end gap-2 p-2">
    <button
      kendoButton
      class="uppercase"
      themeColor="primary"
      fillMode="flat"
      (click)="cancel()"
    >
      {{ 'outlook.buttons.cancel' | translate }}
    </button>
    <button
      kendoButton
      class="uppercase"
      themeColor="primary"
      [disabled]="!form.group.dirty || loading || !form.valid"
      (click)="save()"
    >
      {{ 'outlook.buttons.save' | translate }}
    </button>
  </div>
</div>

<maximizer-outlook-notification #notification [closable]="true">
</maximizer-outlook-notification>
